import React from 'react'
import { Modal, Radio } from 'antd'
import { translateKey as t } from '../../../locales/translation'
import * as XLSX from 'xlsx'
import { downloadBlob } from '../../../utils/helpers'
import _ from 'lodash'

const ExportToCSV = (data, fileName, fields, delimiter, decimal) => {
  const decimalOption = decimal === 'comma' ? ',' : '.'

  const parsedData = []

  data.forEach((el) => {
    const structure = {}

    fields.forEach((field) => {
      let value = typeof field.value === 'function' ? field.value(el) : _.get(el, field.value, '')

      // Check if the value is a number like 1.25, 0.5 etc
      const regex = new RegExp(/\d+[.,]\d{1,10}/)

      if (regex.test(value)) {
        value = value.toString()

        // If the number has dot or comma, we replace it with the selected decimal option
        if (value.includes('.')) {
          value = value.replace('.', decimalOption)
        } else {
          value = value.replace(',', decimalOption)
        }
      }

      if (_.isObject(value) && !_.isEmpty(value)) {
        value = JSON.stringify(value)
      }

      structure[field.label] = value
    })

    parsedData.push(structure)
  })

  // Convert to excel worksheet
  const worksheet = XLSX.utils.json_to_sheet(parsedData)
  // Convert to csv from the worksheet
  const csv = XLSX.utils.sheet_to_csv(worksheet, { FS: delimiter })

  // Create the blob and download
  const csvBlob = new Blob([csv], { type: 'text/csv' })
  downloadBlob(csvBlob, fileName + '.csv')
}

function chooseDelimiter(controller, fileName, fields, hideDecimalOptions = false) {
  // Fetch the value from the cookies if it was saved from the previous selection or set to semicolon by default
  let delimiter = localStorage.getItem('csvDelimiter') || ';'
  let decimal = localStorage.getItem('csvDecimal') || 'comma'
  let exportedData = 'original'

  const isFiltered = controller.filteredColumns.length > 0 || controller.sortBy

  const options = () => {
    return (
      <div>
        <b style={{ display: 'block', marginBottom: 5 }}>{t('lblChooseDelimiterOption', 'Choose delimiter option')}</b>
        <Radio.Group defaultValue={delimiter} onChange={(e) => delimiterOnChange(e)} style={{ marginBottom: 15 }}>
          <Radio value=';'>
            {t('lblSemicolon', 'Semicolon')} <b>( ; )</b>
          </Radio>
          <Radio value=','>
            {t('lblComma', 'Comma')} <b>( , )</b>
          </Radio>
          <Radio value='|'>
            {t('lblPipes', 'Pipes')} <b>( | )</b>
          </Radio>
        </Radio.Group>
        {!hideDecimalOptions && (
          <div>
            <b style={{ display: 'block', marginBottom: 5 }}>{t('lblChooseDecimalOption', 'Choose decimal option')}</b>
            <Radio.Group defaultValue={decimal} onChange={(e) => decimalOnChange(e)} style={{ marginBottom: 15 }}>
              <Radio value='comma'>
                {t('lblComma', 'Comma')} <b>( , )</b>
              </Radio>
              <Radio value='dot'>
                {t('lblDot', 'Dot')} <b>( . )</b>
              </Radio>
            </Radio.Group>
          </div>
        )}
        {isFiltered && (
          <div>
            <b style={{ display: 'block', marginBottom: 5 }}>Export Data As</b>
            <Radio.Group defaultValue={exportedData} onChange={(e) => exportDataOnChange(e)}>
              <Radio value='original'>Original</Radio>
              <Radio value='filtered'>Filtered / Sorted</Radio>
            </Radio.Group>
          </div>
        )}
      </div>
    )
  }

  const delimiterOnChange = (e) => {
    delimiter = e.target.value

    // Store the selection to the cookies
    localStorage.setItem('csvDelimiter', delimiter)
  }

  const decimalOnChange = (e) => {
    decimal = e.target.value

    // Store the selection to the cookies
    localStorage.setItem('csvDecimal', decimal)
  }

  const exportDataOnChange = (e) => {
    exportedData = e.target.value
  }

  Modal.confirm({
    title: t('lblSelectCSVOptions', 'Select CSV Options'),
    content: options(),
    centered: true,
    okText: t('lblExport', 'Export'),
    cancelText: t('lblCancel', 'Cancel'),
    onOk: () => ExportToCSV(exportedData === 'original' ? controller.tableData : controller.sortedFilteredList, fileName, fields, delimiter, decimal)
  })
}

export { chooseDelimiter }
